import React, { useEffect, useState, useRef } from "react";

const Counter = ({ start, end, trigger }) => {
  const [count, setCount] = useState(start);

  useEffect(() => {
    if (!trigger) return;

    const increment = Math.ceil(end / 100); // Calculate the increment value
    const interval = setInterval(() => {
      setCount((prev) => {
        if (prev + increment >= end) {
          clearInterval(interval);
          return end;
        }
        return prev + increment;
      });
    }, 20);

    return () => clearInterval(interval);
  }, [trigger, end]);

  return count;
};

const StatsGrid = () => {
  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        }
      },
      { threshold: 0.8 } // Trigger when 80% of the section is visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={sectionRef}
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-0 text-center mb-6 md:mb-16 w-full justify-evenly poppins"
    >
      {/* Customers */}
      <div data-aos="flip-left">
        <h1 className="text-[#252525] font-extrabold text-4xl md:text-5xl xl:text-6xl">
          <Counter start={1} end={10000} trigger={inView} />
          <span className="text-[#F26422]">+</span>
        </h1>
        <p className="text-[#252525] text-base md:text-lg xl:text-2xl my-4">
          Register Customers
        </p>
      </div>
      {/* Partners */}
      <div data-aos="flip-right">
        <h1 className="text-[#252525] font-extrabold text-4xl md:text-5xl xl:text-6xl">
          <Counter start={1} end={5000} trigger={inView} />
          <span className="text-[#F26422]">+</span>
        </h1>
        <p className="text-[#252525] text-base md:text-lg xl:text-2xl my-4">
          Trusted Partners
        </p>
      </div>
      {/* Agents */}
      <div data-aos="flip-left">
        <h1 className="text-[#252525] font-extrabold text-4xl md:text-5xl xl:text-6xl">
          <Counter start={1} end={3000} trigger={inView} />
          <span className="text-[#F26422]">+</span>
        </h1>
        <p className="text-[#252525] text-base md:text-lg xl:text-2xl my-4">
          Certified Agents
        </p>
      </div>
      {/* Customers (again) */}
      <div data-aos="flip-right">
        <h1 className="text-[#252525] font-extrabold text-4xl md:text-5xl xl:text-6xl">
          <Counter start={1} end={80000} trigger={inView} />
          <span className="text-[#F26422]">+</span>
        </h1>
        <p className="text-[#252525] text-base md:text-lg xl:text-2xl my-4">
          Daily Payments
        </p>
      </div>
    </div>
  );
};

export default StatsGrid;
